import type { TablePaginationConfig } from 'antd';

/** 日期时间格式 */
export const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';

/** 无数据时占位符 */
export const NO_DATA_FALLBACK = '-';

/** 表格页面默认配置 */
export const PAGE_SIZE_OPTIONS = [5, 10, 20, 50, 100];

/** 表格分页器默认参数 */
export const PAGINATION_DEFAULT_CONFIG: TablePaginationConfig = {
  pageSizeOptions: PAGE_SIZE_OPTIONS,
  showTotal: total => `共 ${total} 条`,
  showQuickJumper: true,
  showSizeChanger: true,
  size: 'default',
};

/** 日期时间格式列宽 */
export const DATE_TIME_COLUMN_WIDTH = 200;
